import React from 'react';
import I18n from 'utils/I18n';
import SvgAchievementsTrophyNormalSmall from '@strava/icons/AchievementsTrophyNormalSmall';
import Button from '@strava/ui/Button';
import { segAndBestEffortAchievementsProps } from '../../../../props/feed-prop-types';

import styles from '../index.scss';
import { useFeedEntityContext } from '../../../../state/FeedEntityContext';
import { OPEN_MODAL_ACHIEVEMENTS_TAB } from '../../../../state/feed-entity-actions';

//  Segment Effort And Best Effort Achievements Count
const AchievementCount = ({ segAndBestEffortAchievements }) => {
  const { dispatch } = useFeedEntityContext();

  return (
    <div
      className={`${styles.stat} ${styles.mediaRight} ${styles.textRight} ${
        segAndBestEffortAchievements.length > 0 ? styles.empty : ''
      }`}
      data-testid="achievement_container"
      title={I18n.t('components.feed.social.achievements')}
    >
      <div className={`${styles.statSubtext}`}>
        {I18n.t('components.feed.social.achievements')}
      </div>
      <b className={styles.statText}>
        <span className={styles.appIconWrapper}>
          <span className={styles.iconWrapper}>
            <Button
              variant="icon"
              onClick={() => dispatch({ type: OPEN_MODAL_ACHIEVEMENTS_TAB })}
            >
              <SvgAchievementsTrophyNormalSmall />
            </Button>
          </span>
        </span>
        <span className={styles.count} data-testid="achievement_count">
          {segAndBestEffortAchievements.length}
        </span>
      </b>
    </div>
  );
};

AchievementCount.propTypes = {
  segAndBestEffortAchievements: segAndBestEffortAchievementsProps
};

AchievementCount.defaultProps = {
  segAndBestEffortAchievements: []
};

export default AchievementCount;
